import React from 'react';
import PropTypes from 'prop-types';
import UsersText from 'App/components/UsersText';

export default class Users extends React.Component {
	constructor(props) {
		super(props);

		var t = Tools.$translate;
		this.lang = {
			noAccountManager: t('default.noAccountManager')
		};
	}

	render() {
		if (this.props?.account?.merging) {
			return <td />;
		}

		const hasGroupTreeVirtualizedList = Tools.FeatureHelper.hasSoftDeployAccess('GROUP_TREE_VIRTUALIZED_LIST');
		const Component = hasGroupTreeVirtualizedList && !this.props.createNewAccountRow ? 'div' : 'td';

		return (
			<Component
				className={`DataSourceColumn ${
					hasGroupTreeVirtualizedList && !this.props.createNewAccountRow ? 'align-items-center' : ''
				}`}
			>
				<div
					className={
						!Array.isArray(this.props?.account?.users) || this.props?.account?.users?.length === 0
							? 'no-account-manager'
							: 'with-account-manager'
					}
				>
					<ReactTemplates.TOOLS.avatar size={30} user={this.props?.account?.users?.[0]} />
					<UsersText users={this.props?.account?.users} placeholder={this.lang.noAccountManager}></UsersText>
				</div>
			</Component>
		);
	}
}

Users.propTypes = {
	account: PropTypes.object,
	createNewAccountRow: PropTypes.bool
};
